const images = {
  hamburger_icon: require('../assets/images/HAMBURGER ICON.svg').default,
  logo_white_bg: require('../assets/images/logo_white-bg.svg').default,
  logo_transparant: require('../assets/images/logo_transparant.svg').default,
  downloadIcon: require('../assets/images/DownloadSimple.svg').default,
  heroSection: require('../assets/images/AboutUs_heroSection .svg').default,
  whoWeAre: require('../assets/images/AboutUs_whoWeAreSection.svg').default,
  down: require('../assets/images/DownArrow_icon.svg').default,
  up: require('../assets/images/UpArrow_icon.svg').default,
  facebook_black: require('../assets/images/Facebook_black_icon.svg').default,
  facebook_gray: require('../assets/images/Facebook_gray_icon.svg').default,
  twitter_black: require('../assets/images/TwitterX_black_icon.svg').default,
  twitter_gray: require('../assets/images/TwitterX_gray_icon.svg').default,
  linkedin_black: require('../assets/images/LinkedIn_black_icon.svg').default,
  linkedin_gray: require('../assets/images/LinkedIn_gray_icon.svg').default,
  instagram_black: require('../assets/images/Instagram_black_icon.svg').default,
  instagram_gray: require('../assets/images/Instagram_gray_icon.svg').default,
  whatsapp_white: require('../assets/images/Whatsapp_white_icon.svg').default,
  vector: require('../assets/images/Vector 1.svg').default,
  ourVision: require('../assets/images/Our Vision.svg').default,
  ourMission: require('../assets/images/Our Mission.svg').default,
  left_arrow: require('../assets/images/ArrowCircleLeft.svg').default,
  right_arrow: require('../assets/images/ArrowCircleRight.svg').default,
  person1: require('../assets/images/Person1.svg').default,
  person2: require('../assets/images/Person2.svg').default,
  person3: require('../assets/images/Person3.svg').default,
  person4: require('../assets/images/Person4.svg').default,
  person5: require('../assets/images/Person5.svg').default,
  person6: require('../assets/images/Person6.svg').default,
  person7: require('../assets/images/Person7.svg').default,
  person8: require('../assets/images/Person8.svg').default,
  person9: require('../assets/images/Person9.svg').default,
  person10: require('../assets/images/Person10.svg').default,
  person11: require('../assets/images/Person11.svg').default,
  about_desktop_bg: require('../assets/images/AboutUs_desktop_bg.svg').default,
  about_mobile_bg: require('../assets/images/AboutUs_Mobile_bg.svg').default,
  facebook_footer: require('../assets/images/Facebook_footer.svg').default,
  instagram_footer: require('../assets/images/Instagram_footer.svg').default,
  linkedin_footer: require('../assets/images/LinkedIn_footer.svg').default,
  twitter_footer: require('../assets/images/TwitterX_footer.svg').default,
  madeInIndia: require('../assets/images/make-in-india-seeklogo 1.svg').default,
  heart: require('../assets/images/Heart.svg').default,
  phone: require('../assets/images/Phone.svg').default,
  mail: require('../assets/images/E-Mail.svg').default,
  map: require('../assets/images/Location.svg').default,
  homeSlideOne: require('../assets/images/homeSlideOne.svg').default,
  homeSlideTwo: require('../assets/images/homeSlideTwo.svg').default,
  homeSlideThree: require('../assets/images/homeSlideThree.svg').default,
  about: require('../assets/images/About.svg').default,
  ourProcess: require('../assets/images/OurProcess.svg').default,
  quality: require('../assets/images/Premium.svg').default,
  designs: require('../assets/images/Innovative.svg').default,
  sustainability: require('../assets/images/Sustainability.svg').default,
  customer: require('../assets/images/Customer_Satisfaction.svg').default,
  automotive: require('../assets/images/Automotive.png'),
  industrial: require('../assets/images/Profile.png'),
  architecture: require('../assets/images/Architecture.png'),
  aeronautical: require('../assets/images/Aeronautical.png'),
  heat: require('../assets/images/Heat.png'),
  energy: require('../assets/images/Energy.png'),
  conductor: require('../assets/images/Conductor.png'),
  maritime: require('../assets/images/Maritime.png'),
  rectangle: require('../assets/images/Rectangle.svg').default,
  mapBackground: require('../assets/images/Map.svg').default,
  certification: require('../assets/images/Certification.svg').default,
  a4_1: require('../assets/images/A4 - 1.svg').default,
  a4_2: require('../assets/images/A4 - 2.svg').default,
  a4_3: require('../assets/images/A4 - 3.svg').default,
  a4_4: require('../assets/images/A4 - 4.svg').default,
  careers: require('../assets/images/Career.svg').default,
  core: require('../assets/images/Core.svg').default,
  environment: require('../assets/images/Environment.svg').default,
  growth: require('../assets/images/Growth.svg').default,
  contact: require('../assets/images/ContactUs.svg').default,
  bgRedPhone: require('../assets/images/BgRedPhone.svg').default,
  bgRedEmail: require('../assets/images/BgRedEmail.svg').default,
  bgRedLocation: require('../assets/images/BgRedLocation.svg').default,
  ourProcessMain: require('../assets/images/Our process.svg').default,
  Melting: require('../assets/images/Melting.svg').default,
  BilletCasting: require('../assets/images/Billet Casting.svg').default,
  Extrusion: require('../assets/images/Extrusion.svg').default,
  Stretching: require('../assets/images/Stretching.svg').default,
  Hardening: require('../assets/images/Hardening.svg').default,
  Packaging: require('../assets/images/Packaging.svg').default,
};

export default images;
